import s from './index.module.css';
import { Switch, Tooltip } from "antd";
import { InfoCircleOutlined } from '@ant-design/icons';
import classNames from 'classnames';

const CheckBlock = ({
    label,
    onChange,
    value,
    tooltip,
    className,
    scale = true,
    ...props
}) => {
    return (<div className={classNames(s.block, className)} {...props}>
        <Switch
            defaultChecked
            checked={value}
            onChange={onChange}
            className={classNames({[s.switch]: scale})}
        />
        <span className={s.selectedNumberView}>{ label }</span>
        {
            tooltip && (<Tooltip
                title={tooltip}
                className={s.margin}
            >
                <InfoCircleOutlined />
            </Tooltip>)
        }
    </div>)
}

export default CheckBlock;